<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <BoxPaciente
                ref="BoxPaciente"
                :paciente="paciente"
            />

            <rkm-area
                type="section"
                title="Incluir novo agendamento"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-row>

                            <rkm-col cols="12" v-if="isFromRegulacao && regulacaoSolicitacao.numero">
                                <rkm-form-input
                                    :disabled="isFromRegulacao"
                                    label="Protocolo de fechamento"
                                    v-model="regulacaoSolicitacao.numero"
                                />
                            </rkm-col>

                            <rkm-col cols="8">
                                <rkm-form-input-autocomplete
                                    :disabled="isFromRegulacao"
                                    :repository="repositories.usuario"
                                    :requestQueryStringParams="{ with_not_regularized: true }"
                                    :searchFields="fields.autocomplete.usuario"
                                    :validations="validations.medicoSolicitante"
                                    text-field="cidadaoNome"
                                    label="Profissional solicitante"
                                    placeholder="Digite o nome ou número do conselho profissional"
                                    v-model="agendamento.medicoSolicitante"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-button
                                            :disabled="isFromRegulacao"
                                            @click.stop="$refs.ModalUsuarioSimplificado.open()"
                                            color="primary"
                                            title="Cadastrar novo usuário"
                                        >
                                            <rkm-icon icon="plus" />
                                        </rkm-button>
                                    </rkm-input-group-append>
                                </rkm-form-input-autocomplete>
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-checkbox
                                    v-model="agendamento.urgente"
                                    :label="false"
                                    :disabled="isFromRegulacao"
                                >
                                    Agendamento urgente
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="12" v-if="paciente.anos < 18 || paciente.anos >= 60">
                                <rkm-form-input
                                    label="Responsável pelo paciente"
                                    v-model="agendamento.responsavel"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="paciente.sexoId == this.enums.sexo.FEMININO">

                                <rkm-form-date-picker
                                    label="Data da última menstruação"
                                    :max-date="data.form.dataAtual"
                                    v-model="agendamento.dataMenstruacao"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="paciente.sexoId == this.enums.sexo.FEMININO">
                                <rkm-form-radio-group
                                    label="Gestante"
                                    v-model="agendamento.gestante"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :disabled="isFromRegulacao"
                                    :options="unidades"
                                    label="Unidade solicitante"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="agendamento.unidadeId"
                                    value-field="id"
                                    :validations="validations.unidadeId"
                                    @change="$emit('setFields','unidade')"
                                />
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :disabled="isFromRegulacao"
                                    label="Local de atendimento"
                                    :options="infraestruturas"
                                    textField="nome"
                                    v-model="agendamento.infraestruturaId"
                                    valueField="id"
                                    show-default-option
                                    :validations="validations.infraestruturaId"
                                    @change="$emit('setFields','infraestruturaId')"
                                />
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :options="coleta"
                                    label="Coleta"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="agendamento.coletaUnidadeId"
                                    value-field="id"
                                    :validations="validations.coletaUnidadeId"
                                    :disabled="agendamento.unidadeId && agendamento.infraestruturaId ? false : true"
                                />
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturasColeta"
                                    textField="nome"
                                    v-model="agendamento.coletaInfraestruturaId"
                                    valueField="id"
                                    show-default-option
                                    :validations="validations.coletaInfraestruturaId"
                                    :disabled="agendamento.unidadeId && agendamento.infraestruturaId ? false : true"
                                />
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :disabled="isFromRegulacao"
                                    :options="laboratorios"
                                    label="Laboratório"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="agendamento.laboratorioId"
                                    value-field="id"
                                    :validations="validations.laboratorioId"
                                    @change="$emit('setFields','laboratorioId')"
                                />
                            </rkm-col>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :disabled="isFromRegulacao"
                                    label="Local de atendimento"
                                    :options="infraestruturasLaboratorio"
                                    textField="nome"
                                    v-model="agendamento.laboratorioInfraestruturaId"
                                    valueField="id"
                                    show-default-option
                                    :validations="validations.laboratorioInfraestruturaId"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="agendamento.showInfo"
                                cols="12"
                            >

                                <rkm-area title="Exame(s)" no-margin-top>
                                    <rkm-row>
                                        <rkm-col cols="12">
                                            <rkm-list
                                                :items="agendamento.incluido"
                                                :fields="fields.tables.exame"
                                                hide-filters
                                                hide-pagination
                                                item-cursor="default"
                                            >
                                                <template v-slot="{ item }">

                                                    <rkm-row>
                                                        <rkm-col cols="12">
                                                            {{ getExame(item) }}
                                                        </rkm-col>
                                                        <rkm-col
                                                        v-if="item.observacaoColeta"
                                                            cols="12"
                                                            class="obsExame"
                                                        >
                                                            <strong>Obs:</strong> {{item.observacaoColeta}}
                                                        </rkm-col>
                                                    </rkm-row>
                                                </template>
                                            </rkm-list>
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>

                            <rkm-col
                                v-if="agendamento.showInfo"
                                cols="6"
                            >

                                <rkm-area title="Data">
                                    <rkm-row>
                                        <rkm-col>
                                            <rkm-form-date-picker
                                                name="Data"
                                                v-model="agendamento.data"
                                                disabled
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>

                            <rkm-col
                                v-if="agendamento.showInfo"
                                cols="6"
                            >

                                <rkm-area title="Horário">
                                    <rkm-row>
                                        <rkm-col>
                                            <rkm-form-time-picker
                                                name="Horário"
                                                v-model="agendamento.horaInicial"
                                                disabled
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="12">

                                <rkm-area title="Uso de medicamento">

                                    <rkm-button
                                        title="Visualizar histórico"
                                        color="primary"
                                        slot="trailing"
                                        small
                                        @click.stop="$refs.ModalHistorico.open(paciente.id)"
                                    >
                                        <rkm-icon icon="search" />
                                    </rkm-button>

                                    <rkm-form-textarea
                                        name="Medicamentos"
                                        v-model="agendamento.medicamentos"
                                        :validations="validations.medicamentos"
                                        rows="4"
                                        max-rows="4"
                                    />
                                </rkm-area>
                            </rkm-col>

                            <rkm-col cols="12">

                                <rkm-area title="Suspeita clínica">

                                    <rkm-form-textarea
                                        :disabled="isFromRegulacao"
                                        name="Suspeita"
                                        v-model="agendamento.suspeita"
                                        :validations="validations.suspeita"
                                        maxlength="5000"
                                        rows="4"
                                        max-rows="4"
                                    />
                                </rkm-area>
                            </rkm-col>

                            <rkm-col cols="12">

                                <rkm-area title="Observação">

                                    <rkm-form-textarea
                                        name="Observação"
                                        v-model="agendamento.observacao"
                                        :validations="validations.observacao"
                                        rows="4"
                                        max-rows="4"
                                    />
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-col class="flex-grow-1">
                            <rkm-calendar
                                :items="diasCalendario"
                                @click="openModal"
                            />
                        </rkm-col>

                        <rkm-row>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-verde flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">vagas disponíveis</rkm-col>
                            </rkm-col>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-azul flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">data selecionada</rkm-col>
                            </rkm-col>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-roxo flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">datas agendadas</rkm-col>
                            </rkm-col>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-vermelho flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">vagas atingidas</rkm-col>
                            </rkm-col>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center" cols="2">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-amarelo flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">feriado/facultativo</rkm-col>
                            </rkm-col>
                            <rkm-col class="flex-grow-1 d-flex justify-content-center align-items-center">
                                <rkm-icon
                                    icon="exclamation-circle"
                                    class="leg-vermelho flex-grow-0"
                                    small
                                />
                                <rkm-col class="mt-1 pt-0 col-8">datas bloqueadas</rkm-col>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <ModalUsuarioSimplificado
                ref="ModalUsuarioSimplificado"
                @save="handleSaveUsuarioSimplificado"
            />

        </rkm-form>

        <Modal
            ref="RkmModal"
            :data="data"
            :paciente="paciente"
            :agendamento="agendamento"
            :jornadas="jornadas"
            :index="index"
            :vagas="vagas"
            :horarioAgendamento="horarioAgendamento"
            :regulacao-solicitacao="regulacaoSolicitacao"
            :reagendar="reagendar"
            @handleSaveAgendamento="handleSaveAgendamento"
        />

        <ModalHistorico
            ref="ModalHistorico"
            :paciente="paciente"
        />

        <ModalAgendar
            ref="ModalAgendar"
            :paciente="paciente"
            :agendamento="agendamento"
            :data="data"
            @agendarAmbulatorioAtendimento="agendarAmbulatorioAtendimento"
            @multipleAmbulatorioAtendimento="multipleAmbulatorioAtendimento"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @openModal="openModal"
            @resetForm="resetForm"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, stringCase, object, data, calculations, formats } from '@/mixins'

// Components.
import Modal from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/exames/Modal'
import ModalHistorico from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/ModalHistorico'
import ModalAgendar from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/agendar/Modal'
import ModalUsuarioSimplificado from '@/components/cadastro/usuario/components/cadastro-simplificado/Modal'
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'
import BoxPaciente from '@/components/exame-laboratorial/agendamento-exame/paciente/Index'

// Filters.
import filterFormats from '@/filters/formats'

// Enuns.
import modulo from '@/enums/cadastro/feriado/modulo'
import abrangencia from '@/enums/cadastro/feriado/abrangencia'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

// Moment.
import moment from 'moment'

export default {
    components: { Modal, ModalHistorico, ModalUsuarioSimplificado, ModalPermissao, BoxPaciente, ModalAgendar},
    computed: {
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
                tables: {
                    exame: [
                        { key: 'nome', label: 'Exame', sortable: true },
                    ],
                }
            }
        },
        infraestruturas() {

            if (this.agendamento.unidadeId) {

                let infraestruturaPrincipal = this.unidades.find(u => u.id === this.agendamento.unidadeId)

                if (infraestruturaPrincipal) {

                    let infraestruturas = infraestruturaPrincipal.infraestruturas

                    if (!this.data.form.isSupervisor && !this.isFromRegulacao) {

                        infraestruturas = infraestruturas.filter(u => u.id == this.data.form.infraestruturaId)
                    }

                    if (!this.agendamento.unidadeDisabled) {

                        this.$emit('loadInfraestrutura', infraestruturas)
                    }

                    return infraestruturas
                }
            }

            return []
        },
        laboratorios() {

            let laboratorio = this.data.form.unidadesParametrizada
                ? this.data.form.unidadesParametrizada.filter(unidade => unidade.laboratorio)
                : []

            this.loadLaboratorio(laboratorio)

            return laboratorio
        },
        infraestruturasLaboratorio() {

            if (this.agendamento.laboratorioId) {

                let laboratorio = this.laboratorios.find(u => u.id === this.agendamento.laboratorioId)

                if (laboratorio) {

                    let infraestruturaPrincipal = []

                    laboratorio.infraestruturas.forEach(infraestrutura => {

                        if (!infraestruturaPrincipal.find(u => u.id === infraestrutura.id)) {

                            infraestruturaPrincipal.push(infraestrutura)
                        }
                    })

                    if (!this.agendamento.unidadeDisabled) {
                        this.loadLaboratorioPrincipal(infraestruturaPrincipal)
                    }

                    return infraestruturaPrincipal
                }
            }

            return []
        },
        coleta() {

            return this.data.form.unidadesParametrizada
                ? this.data.form.unidadesParametrizada.filter(unidade => unidade.coleta && unidade.infraestruturas
                    .find(infraestrutura => infraestrutura.unidadeSolicitanteInfraestruturaId == this.agendamento.infraestruturaId))
                : []
        },
        infraestruturasColeta() {

            if (this.agendamento.coletaUnidadeId) {

                let unidade = this.coleta.find(u => u.id == this.agendamento.coletaUnidadeId)

                if (unidade) {
                    return unidade.infraestruturas
                        .filter(infraestrutura => infraestrutura.unidadeSolicitanteInfraestruturaId == this.agendamento.infraestruturaId)
                }
            }

            return []
        },
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                laboratorioId: { required: true },
                laboratorioInfraestruturaId: { required: true },
                coletaUnidadeId: { required: true },
                coletaInfraestruturaId: { required: true },
                medicoSolicitante: { required: true },
                medicamentos: { min: 3, max: 500 },
                suspeita: { min: 3, max: 5000 },
                observacao: { min: 3, max: 500 },
            }
        },
        isFromRegulacao() {

            return !!this.regulacaoSolicitacao
        }
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }
    },
    data: () => ({
        defaultItem: null,
        enums: {
            modulo,
            abrangencia,
            preferenciaNome,
            sexo,
            tipoCota,
            tipoUnidade
        },
        cota: [],
        exames: [],
        tabIndex: 1,
        requestAuthorization: true,
        cotas: [],
        isAutorizado: false,
        alertSupervisor: null,
     }),
    filters: {
        ...filterFormats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSaveUsuarioSimplificado(usuario) {

            if (usuario.nome) {

                usuario.cidadaoNome = usuario.nome
            }

            if (usuario) {

                this.agendamento.medicoSolicitante = this.clone(usuario)
            }
        },
        loadLaboratorioPrincipal(infraestruturaPrincipal) {

            if (this.isFromRegulacao) {

                if (infraestruturaPrincipal.find(i => i.id === this.regulacaoSolicitacao.prestador.infraestruturaId)) {

                    this.agendamento.laboratorioInfraestruturaId = this.regulacaoSolicitacao.prestador.infraestruturaId
                }
                else {

                    this.showWarningNotification('O local de atendimento do laboratório prestador não está disponível para seleção.')
                }
            }
            else {

                this.agendamento.laboratorioInfraestruturaId = infraestruturaPrincipal.find(u => u.principal).id
            }
        },
        loadColetaPrincipal() {

            let unidade = this.coleta.find(u => u.id == this.agendamento.coletaUnidadeId)
            let novaInfraId = unidade?.infraestruturas.find(u => u.principal)?.id || null

            if (this.agendamento.coletaInfraestruturaId !== novaInfraId) {
                this.agendamento.coletaInfraestruturaId = novaInfraId;
            }
        },
        openModal(item, requestAuthorization, supervisorId){
            if (this.datasBloqueadas.filter(data => moment(data, 'DD/MM/YYYY').isSame(item.date) ).length > 0) {
                return false
            }

            if (!this.agendamento.laboratorioInfraestruturaId) {

            this.showAlert('É necessário informar o laboratório para continuar.','Atenção')
                return false
            }

            if(requestAuthorization == false){

                this.requestAuthorization = requestAuthorization
                this.isAutorizado = true
            }

            if(supervisorId){

                this.agendamento.supervisorId = supervisorId
            }

            let feriado = []

            this.data.form.feriados.map(feriadoExameLaboratorial =>

                feriado.push(feriadoExameLaboratorial)
            )

            if (this.agendamento.coletaInfraestruturaId) {

                if (item) {

                    let diaTratado = moment(item.date).format('YYYY-MM-DD')
                    let dataAtual = this.data.form.dataAtual.split("/").reverse().join("-")

                    const diaSelecionado = this.jornadas.find(
                        dias => dias.data.split("/").reverse().join("-") == diaTratado
                    )

                    if (!diaSelecionado) {
                        return false
                    }

                    const isFeriado = feriado.some(f =>
                        f.data.split("/").reverse().join("-") === diaTratado
                        && (f.abrangencia === this.enums.abrangencia.TODAS || f.infraestruturaIds.includes(this.agendamento.coletaInfraestruturaId))
                    )

                    if (isFeriado) {
                        return false
                    }

                    this.agendamento.jornadaId = diaSelecionado.jornadaId

                    let cadastrados = item.attributes[0].customData.title.split('/')

                    const diasVagas = this.jornadas.filter(
                        dias => dias.data.split("/").reverse().join("-") == diaTratado
                    );

                    const vagas = diasVagas.reduce((total, dia) => total + Number(dia.vagas || 0) + Number(dia.vagasApp || 0), 0);

                    if (vagas <= cadastrados[0] && !moment(diaTratado).isBefore(dataAtual)
                        && diaTratado !== this.agendamento.data && this.requestAuthorization) {

                            const confirm = async () => {

                                this.alertSupervisor = this.agendamento.agendamentoId

                                this.$refs.RkmModalPermissao.open(item)

                                return false
                            }

                            const cancel = async () => {}

                            const msg = 'O número de vagas foi atingido, para continuar é necessário informar' +
                                ' os dados do supervisor. Deseja continuar?'

                                this.showConfirmation(msg, confirm, cancel)

                            return false

                    } else if (diaSelecionado && moment(diaTratado).isAfter(dataAtual)
                        || diaSelecionado && diaTratado == dataAtual
                        || diaSelecionado && diaTratado == this.agendamento.data){

                            this.$refs.RkmModal.open(diaSelecionado, this.requestAuthorization)

                            this.requestAuthorization = true
                    }
                }
            }
        },
        handleSaveAgendamento(exames, itemSelecionado, horarioAtendimento){

            if (exames.length > 0) {
                this.exames = exames
                this.agendamento.incluido = exames
            }

            this.agendamento.data = itemSelecionado.data.split("/").reverse().join("-")

            if (horarioAtendimento !== null) {
                this.agendamento.horaInicial = horarioAtendimento
            }

            this.agendamento.exameNome = itemSelecionado.exameNome
            this.agendamento.jornadaId = itemSelecionado.jornadaId
            this.agendamento.pacienteId = this.paciente.id
            this.agendamento.showInfo = true
            this.agendamento.alterado = true
            this.$emit('loadCalendario', this.agendamento.data)

            if (this.agendamento.ambulatorioAtendimento) {

                this.loadCota()
            }
        },
        resetForm(){

            this.alertSupervisor = null
            this.agendamento.alterado = false
            this.isAutorizado = false

            this.$emit('backTabs')
        },
        loadLaboratorio(unidades) {

            if (this.isFromRegulacao) {

                if (unidades.find(u => u.id === this.regulacaoSolicitacao.prestador.unidadeId)) {

                    this.agendamento.laboratorioId = this.regulacaoSolicitacao.prestador.unidadeId
                }
                else if (this.loaded) {

                    this.showWarningNotification('O laboratório prestador não está disponível para seleção.')
                }
            }
            else if (unidades.length === 1) {

                this.agendamento.laboratorioId = unidades[0].id
            }
            else if (Array.isArray(this.data.form.laboratorioPadrao) && this.data.form.laboratorioPadrao != null) {
                const unidadesLaboratorio = this.data.form.laboratorioPadrao;

                const laboratorio = unidadesLaboratorio.find(lab => lab.unidadeId == this.agendamento.laboratorioId);

                if (laboratorio && laboratorio.laboratorioPadraoInfraestrutura) {

                    const laboratorioUnidade = laboratorio.laboratorioPadraoInfraestrutura.unidade;
                    this.agendamento.laboratorioId = laboratorioUnidade.id;
                }
            }
        },
        validate() {

            return this.$refs.Form.validate()
        },
        loadCota() {

            if (this.agendamento.data && !this.isAutorizado) {

                this.setLoading()

                this.repositories.agendamento.getCotas({
                    infraestrutura_id: this.agendamento.infraestruturaId,
                    laboratorio_infraestrutura_id: this.agendamento.laboratorioInfraestruturaId,
                    agendamento_id: this.agendamento.agendamentoId,
                    data: this.agendamento.data
                })
                    .then(response => {
                        this.cota = response.data
                        this.handleSaldo()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleCota() {

            let valorTotalExame = 0

            if (this.agendamento.incluido.length > 0) {

                this.agendamento.incluido.map(exame => {

                    valorTotalExame += parseFloat(exame.valor)
                })
            }

            if (this.cota.laboratorioQuantidade && this.cota.laboratorioQuantidade.saldo <= 0) {

                return true
            }

            if (this.cota.laboratorioValor) {

                if (this.cota.laboratorioValor.saldo <= 0
                    || this.formatSumMoney(this.formatMoney(this.cota.laboratorioValor.saldo, 2)) <= valorTotalExame
                ) {

                    return true
                }
            }

            if (this.cota.unidadeSolicitanteQuantidade && this.cota.unidadeSolicitanteQuantidade.saldo <= 0) {

                return true
            }

            if (this.cota.unidadeSolicitanteValor) {

                if (this.cota.unidadeSolicitanteValor.saldo <= 0
                    || this.formatSumMoney(this.formatMoney(this.cota.unidadeSolicitanteValor.saldo, 2)) <= valorTotalExame
                ) {

                    return true
                }
            }

            return false
        },
        handleCotaExame(exame) {

            let valorExame = exame.valor
            let exameId = exame.exameId

            if (this.cota.exameQuantidade) {

                let exameQuantidade = this.cota.exameQuantidade.find(e => e.exameId === exameId)

                if (exameQuantidade && exameQuantidade.saldo <= 0) {

                    return true
                }
            }

            if (this.cota.exameValor) {

                let exameValor = this.cota.exameValor.find(e => e.exameId === exameId)

                if (exameValor && exameValor.saldo < valorExame) {

                    return true
                }
            }

            if (this.cota.examePeriodoQuantidade) {

                let examePeriodoQuantidade = this.cota.examePeriodoQuantidade.find(e => e.exameId === exameId)

                if (examePeriodoQuantidade && examePeriodoQuantidade.saldo && examePeriodoQuantidade.saldo <= 0) {

                    return true
                }
            }

            if (this.cota.examePeriodoValor) {

                let examePeriodoValor = this.cota.examePeriodoValor.find(e => e.exameId === exameId)

                if (examePeriodoValor && examePeriodoValor.saldo && examePeriodoValor.saldo < valorExame) {

                    return true
                }
            }

            return false
        },
        handleSaldo() {

            if (this.isAutorizado == false && !this.isUnidadeUrgencia() && this.handleCota()) {

                const confirm = async () => {

                    this.alertSupervisor = this.agendamento.agendamentoId

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => {

                    this.resetForm();
                }

                const msg = 'A cota foi atingida, para continuar é necessário informar' +
                    ' os dados do supervisor. Deseja continuar?'

                    this.showConfirmation(msg, confirm, cancel)

                return false
            }

            this.agendamento.incluido.forEach(exame => {

                if (this.isAutorizado == false && !this.isUnidadeUrgencia() && this.handleCotaExame(exame)) {

                    const confirm = async () => {

                        this.alertSupervisor = this.agendamento.agendamentoId

                        this.$refs.RkmModalPermissao.open()

                        return false
                    }

                    const cancel = async () => {

                        this.resetForm()
                    }

                    const msg = 'A cota de exame foi atingida, para continuar é necessário informar' +
                    ' os dados do supervisor. Deseja continuar?'

                    this.showConfirmation(msg, confirm, cancel)

                    return false
                }
            })
        },
        getExame(item) {

            return item.codigo ? `${item.codigo} - ${item.nome}` : item.nome;
        },
        isUnidadeUrgencia() {

            const unidadeSolicitante = this.data.form.unidades.find(unidade => unidade.id == this.agendamento.unidadeId)

            return unidadeSolicitante && unidadeSolicitante.urgencia ? true : false
        },
        agendarAmbulatorioAtendimento(item) {
            this.$emit('agendarAmbulatorioAtendimento', item)
        },
        multipleAmbulatorioAtendimento(exames) {
            this.$emit('multipleAmbulatorioAtendimento', exames)
        },
        handleLaboratorio() {

            if (this.agendamento.coletaUnidadeId) {

                const unidade = this.coleta.find(unidade => unidade.id == this.agendamento.coletaUnidadeId)

                const unidadeEncontrada = this.laboratorios.find(unidades =>
                    unidades.infraestruturas.some(infra => infra.id === unidade.laboratorioPadraoInfraestruturaId)
                );

                if (unidadeEncontrada && unidade.laboratorioPadraoInfraestruturaId) {

                    this.agendamento.laboratorioId = unidadeEncontrada.id
                    this.agendamento.laboratorioInfraestruturaId = unidade.laboratorioPadraoInfraestruturaId
                }
            }
        },
        handleLaboratorioPadraoColeta() {
            const infraestruturaId = this.agendamento.coletaInfraestruturaId;

            if (!infraestruturaId) {
                this.agendamento.laboratorioId = null;
                this.agendamento.laboratorioInfraestruturaId = null;
                return;
            }

            const unidade = this.data.form.unidadesParametrizada.find(unidade =>
                unidade.infraestruturas.some(infra => infra.id === infraestruturaId)
            );

            if (unidade?.laboratorioPadraoInfraestruturaId) {
                const laboratorioInfraId = unidade.laboratorioPadraoInfraestruturaId;

                const laboratorio = this.laboratorios.find(lab =>
                lab.infraestruturas.some(infra => infra.id === laboratorioInfraId)
                );


                if (laboratorio) {
                    this.agendamento.laboratorioId = laboratorio.id;
                    this.agendamento.laboratorioInfraestruturaId = unidade.laboratorioPadraoInfraestruturaId;
                } else {
                    this.agendamento.laboratorioId = null;
                    this.agendamento.laboratorioInfraestruturaId = null;
                }
            } else {
                this.agendamento.laboratorioId = null;
                this.agendamento.laboratorioInfraestruturaId = null;
            }
        }
    },
    mixins: [ error, repository, stringCase, object, data, calculations, formats],
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true },
        agendamento: { type: Object, required: true },
        vagas: { type: Array, required: true },
        jornadas: { type: Array, required: true },
        feriado: { type: Array, required: true },
        index: { type: Number, default: null },
        horarioAgendamento: { type: String, default: null },
        diasCalendario: {type: Array, required: true},
        unidades: { type: Array, required: true },
        regulacaoSolicitacao: { type: Object },
        loaded: { type: Boolean, required: true },
        reagendar: { type: Object },
        datasBloqueadas: { type: Array, required: true },
    },
    watch: {
        'data.form.exibirExameAmbulatorioAtendimento': function (value) {

            if (value) {

                this.$refs.ModalAgendar.open();
            }
        },
        'agendamento.agendamentoId': function () {

            this.isAutorizado = false
        },
        'agendamento.coletaUnidadeId': function () {

            this.loadColetaPrincipal()

            if (this.index == null) {

                this.$emit('setFields','coletaUnidadeId')
            }
        },
        'agendamento.coletaInfraestruturaId': function () {

            if (this._supressLoadVagas) return

            if (this.index == null || this.agendamento.carregaJornada) {

                this.$emit('setFields','coletaInfraestruturaId')

            }

            this.$nextTick(() => {
                this.handleLaboratorioPadraoColeta();
            });
        },
        'agendamento.laboratorioInfraestruturaId': function (value) {

            if (value && this.agendamento.supervisor && this.agendamento.alterado){
                this.loadCota()
            }
        },
        'feriado': function () {

            let diasCalendario = []

            this.data.form.feriados
                .filter(feriado => feriado.abrangencia === this.enums.abrangencia.TODAS || feriado.infraestruturaIds.includes(this.agendamento.coletaInfraestruturaId))
                .forEach(feriado => {

                    diasCalendario.push({
                        'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'yellow',
                        'title': feriado.tipoNome,
                        'popover':  feriado.observacao
                    })
                })

            this.$emit('loadDiasCalendario', diasCalendario)
        },
        'datasBloqueadas': function ()  {
            let diasCalendario = []

            this.data.form.datasBloqueadas.map(dataBloqueada => {
                diasCalendario.push({
                    clickable: false,
                    dates: moment(dataBloqueada, 'DD/MM/YYYY'),
                    highlight: 'red',
                    popover: 'Data bloqueada para agendamento.',
                    title: 'Bloqueada',
                })
            })

            this.$emit('loadDiasCalendario', diasCalendario)
        },
    }
}
</script>

<style scoped>
.calendario {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.calendario img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
.form-group-radio-button-disabled, .form-group-checkbox-button-disabled {
    width: 100%
}
p {
    margin: 0px;
}
.obsExame {
    font-size: 12px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}

.leg-verde {
    color: #38a169;
    margin-top: 10px;
}

.leg-azul {
    color: #3182ce;
    margin-top: 10px;
}

.leg-vermelho {
    color: #e53e3e;
    margin-top: 10px;
}

.leg-roxo {
    color: #6610f2;
    margin-top: 10px;
}

.leg-amarelo {
    color: #d69e2e;
    margin-top: 10px;
}
</style>